import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { finalize } from 'rxjs';

import { Authority } from '../core/model/authority.model';
import { SessionQuery } from '../core/state/session.query';
import { GitlabProject } from '../shared/model/gitlab.model';
import { News } from '../shared/model/news.model';
import { DelegationService } from '../shared/service/delegation.service';
import { GitlabService } from '../shared/service/gitlab.service';
import { NewsService } from '../shared/service/news.service';
import { ProjectService } from '../shared/service/project.service';
import { SearchWithPagination } from '../shared/utils/request-util';
import { NewsDetailComponent } from './modal/news-detail.component';
import { NgIf, NgFor } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { BackgroundClassDirective } from '../shared/directive/background-add-class.directive';




@Component({
    selector: 'mgp-homepage',
    templateUrl: './home.component.html',
    imports: [NgIf, RouterLink, FaIconComponent, NgxSpinnerComponent, NgFor, BackgroundClassDirective]
})
export class HomeComponent implements OnInit{
gitlabProjects: GitlabProject[] = [];
gitlabProjectLoading = false;
news: News[] = [];
count = 0;
isRoleReferente = false;
isDelegated = false;

constructor(
    private router: Router,
    private modalService: NgbModal,
    private gitlabService: GitlabService,
    private newsService: NewsService,
    private spinnerService: NgxSpinnerService,
    private projectService: ProjectService,
    private sessionQuery: SessionQuery,
    private delegationService: DelegationService,
    ) {}

ngOnInit(): void {
    this.gitlabProjectLoading = true;
    this.spinnerService.show('projectSpinner');
    

    this.gitlabService.getOwnedProjects().pipe(
        finalize(() => {
            this.spinnerService.hide('projectSpinner');
            this.gitlabProjectLoading = false;
        })
    )
    .subscribe((response: HttpResponse<GitlabProject[]>) => {
        this.gitlabProjects = response.body!;
    });

    const req = {} as SearchWithPagination;
    req.page = 0;
    req.size = 5;
    req.sort = ['id,desc'];
    this.newsService.query(req).subscribe((response: HttpResponse<News[]>) => {
        this.news = response.body!;
    });

    /** Jira 1026 
     * Getting number of the projects to be approved, only for Admin user
    */
    this.isRoleReferente= this.sessionQuery.hasAnyAuthority(Authority.ROLE_REFERENTE_ENTE);

    /** Jira 1289
     * Checks if user is delegated and gets the number of his delegated projects
     */
    const observer = this.delegationService.isDelegatedUser();
    observer.subscribe((response: boolean) => {
        this.isDelegated = response;
        if (this.isDelegated){
            this.projectService.getDelegatedProjetsNumber()
            .subscribe((delegated: HttpResponse<string>) => {
                this.count = Number(delegated.body!);
                if (this.isRoleReferente){
                    this.projectService.getWaitingProjetsNumber()
                    .subscribe((data: HttpResponse<string>) => {
                        this.count += Number(data.body!);
                    });
                }
            });
        } else {
        if (this.isRoleReferente){
            this.projectService.getWaitingProjetsNumber()
            .subscribe((data: HttpResponse<string>) => {
                this.count += Number(data.body!);
            });
        }
        }
    });

    // if (this.isRoleReferente || this.isDelegated){
    //     this.projectService.getWaitingProjetsNumber()
    //     .subscribe((response: HttpResponse<string>) => {
    //         this.count += Number(response.body!);
    //     });
    // }
}


openNews(news: News): void {
    const modalRef = this.modalService.open(NewsDetailComponent, {size: 'md'});
    const componentInstance = modalRef.componentInstance as NewsDetailComponent;
    componentInstance.news = news;
}


getFullProjectNamespace(fullName: string): string {
    return fullName.substring(0, fullName.lastIndexOf("/") + 1);
}
}